// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/departure-clearance-procedures.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/departure-clearance-procedures/departure-clearance-procedures.js';

mount([g0]);
